import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteGroup } from '../api/groups';
import { customConfirm } from '../utils/utils';
import { getImageUrl } from '../api';
import { Button } from './Button';
import S from './ProductItem.styl';
var ProductGroupItem = /** @class */ (function (_super) {
    __extends(ProductGroupItem, _super);
    function ProductGroupItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var group = _this.props.group;
            if (group) {
                customConfirm(i18n.productsDeleteGroupSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: group.id,
                        };
                        deleteGroup(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.group);
            }
        };
        return _this;
    }
    ProductGroupItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    ProductGroupItem.prototype.render = function () {
        var props = this.props;
        var group = props.group;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.productItem }, group ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell + " imageCell" },
                    React.createElement("img", { src: getImageUrl(group.image || '') })),
                React.createElement("div", { className: S.tableCell }, group.title),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    ProductGroupItem = __decorate([
        inject('store'),
        observer
    ], ProductGroupItem);
    return ProductGroupItem;
}(React.Component));
export { ProductGroupItem };
